document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.getElementById('age-check-overlay');
  if (!overlay) return;

  var yesBtn = overlay.querySelector('[data-age-yes]');
  var noBtn  = overlay.querySelector('[data-age-no]');

  var hasAgeVerified = window.localStorage.getItem('sp_age_verified') === 'true';

  if (!hasAgeVerified) {
    overlay.classList.add('is-active');
    overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function acceptAge() {
    try {
      window.localStorage.setItem('sp_age_verified', 'true');
    } catch (e) {}
    overlay.classList.remove('is-active');
    overlay.setAttribute('hidden', 'true');
    document.body.style.overflow = '';
  }

  function denyAge() {
    try {
      window.localStorage.removeItem('sp_age_verified');
    } catch (e) {}
    window.location.href = 'https://www.google.com';
  }

  if (yesBtn) yesBtn.addEventListener('click', acceptAge);
  if (noBtn)  noBtn.addEventListener('click', denyAge);
});
